import { render, staticRenderFns } from "./SwitchPercentOrNumberComparativePreviousTournaments.vue?vue&type=template&id=39e864fc&scoped=true&"
import script from "./SwitchPercentOrNumberComparativePreviousTournaments.vue?vue&type=script&lang=js&"
export * from "./SwitchPercentOrNumberComparativePreviousTournaments.vue?vue&type=script&lang=js&"
import style0 from "./SwitchPercentOrNumberComparativePreviousTournaments.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SwitchPercentOrNumberComparativePreviousTournaments.vue?vue&type=style&index=1&id=39e864fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e864fc",
  null
  
)

export default component.exports